const eint = (id) => {
  if (id) {
    return id.toString()
  }

  return id
}

export class BulkWrapper {
  constructor(appState) {
    const entities = appState.jsonApiEntities || {}
    Object.keys(entities).forEach((entityType) => {
      Object.defineProperty(this, entityType, {
        configurable: false,
        enumerable: true,
        get: () =>
          Object.keys(entities[entityType]).map((entityId) =>
            jsonApiWrapper({
              data: entities[entityType][entityId],
              state: appState,
            })
          ),
      })
    })
  }
}

const getRelationFromState = (target, name, state) => {
  const targetRelation = target.relationships[name]
  if (!targetRelation || typeof targetRelation === 'function') {
    return {}
  }
  const dest = targetRelation.type
  const entity = state.jsonApiEntities[dest]
  return wrappedObject(entity[eint(targetRelation.id)], state)
}

const proxiedGetter = (state, target, name, stack) => {
  if (target.relationships && target.relationships[name]) {
    if (Array.isArray(target.relationships[name])) {
      const directRelations = new Set(target.relationships[name])

      return Array.from(directRelations)
        .map((r) => {
          if (state.jsonApiEntities[r.type]) {
            return wrappedObject(
              state.jsonApiEntities[r.type][eint(r.id)],
              state
            )
          }
          return {}
        })
        .filter((relation) => Boolean(relation))
    }
    return getRelationFromState(target, name, state)
  }
  if (target[name] && typeof target[name] === 'object') {
    return wrappedObject(target[name], state, stack.concat(name))
  }
  return target[name]
}

const wrappedObject = (data, state, stack = []) => {
  if (typeof data !== 'object') {
    return data
  }
  const wrappedData = { ...data }
  if (wrappedData.relationships) {
    Object.keys(data.relationships).forEach((relation) => {
      Object.defineProperty(wrappedData, relation, {
        configurable: false,
        enumerable: true,
        get: () => proxiedGetter(state, data, relation, stack),
      })
    })
  }
  return wrappedData
}

export const jsonApiWrapper = ({ data, state }) => wrappedObject(data, state)
